<span *ngIf="description as desc"
  class="avs-station-meta-info"
  [ngClass]="layout === 'inline' ? 'avs-station-meta-info-inline' : 'avs-station-meta-info-stacked'">{{ desc }}</span>
